import React from "react";
import EmbassyDetails from "../common/EmbassyDetails";
import LanguageSelection from "../common/LanguageSelection";
import AddressDetails from "./AddressDetails";
import ReceiverDetails from "./ReceiverDetails";
import ContactInfoVerification from "./ContactInfoVerification";
import GoodConductEnterDetails from "./GoodConductEnterDetails";
import GoodBookingSuccess from "./GoodBookingSuccess";
import ReviewDetails from "./ReviewDetails";
import ShippingSenderStep from "./ShippingSenderStep";
import ShippingReceiverStep from "./ShippingReceiverStep";
import ShippingReviewStep from "./ShippingReviewStep";
import EpOverlayLoader from "../common/EpOverlayLoader";

function BookingDetails(props) {
  const { step, values } = props;
  /** Disable otp for development purpose */
  // if (step.id === "contact-verification") {
  //   step.id = "review-details";
  // }

  
  return (
    <div>
      <div className="container-fluid always-ltr">
        <div className="row">
          <div className={step.id + " col-md-4 embassy-detail-section"}>
            <div className="grey-section">
              <div className="grey-logo-sec">
                  <EmbassyDetails {...props}/>
                  <div className="arrow-top">
                      <img src="./images/arrow-icon.svg" alt="arrow" />
                  </div> 
              </div>
            </div>            
          </div>
          <div className="col-md-8 dir-left" id="right-section">
            <div className="row">
              <div className="col-sm-10">
                <div className="row mt-4 always-right">
                <div className="col-lg-1">&nbsp;</div>
                  <div className="col-lg-11 d-none d-md-block">                    
                    <LanguageSelection {...props} />
                  </div>
                </div>
                <div className="row align-items-center mt-5">
                  <div className="col-lg-1">&nbsp;</div>
                  <div className="col-lg-11">
                    {step.id === "address-details" && (
                      <AddressDetails {...props} />
                    )}
                    {step.id === "contact-verification" && (
                      <ContactInfoVerification {...props} />
                    )}
                    {step.id === "good-enter-details" && (
                      <GoodConductEnterDetails {...props} />
                    )}
                    {step.id === "shipping-sender" && (
                      <ShippingSenderStep {...props} />
                    )}
                    {step.id === "shipping-receiver" && (
                      <ShippingReceiverStep
                        key={`shipping-receiver-${props.values.shippingDetails?.receiver?.email || "new"}-${props.values.shippingDetails?.receiver?.cityCode || ""}`}
                        {...props}
                      />
                    )}
                    {step.id === "shipping-review" && (
                      <ShippingReviewStep {...props} />
                    )}
                    {step.id === "good-booking-success" && (
                      <GoodBookingSuccess {...props} />
                    )}
                    {step.id === "review-details" && (
                      <ReviewDetails {...props} />
                    )}
                    {step.id === "receiver-details" && (
                      <ReceiverDetails {...props} />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      { values.isLoading && <EpOverlayLoader text={values.loaderText} />}
    </div>
  );
}

export default BookingDetails;
